module.exports = __webpack_public_path__ + "img/social-icon-linkedin.92fb7fa4.svg";